import React from 'react';
import { useAppProductionWarning } from './useAppProductionWarning';

export const ProductionWarningProvider = ({ children }) => {
  const productionWarning = useAppProductionWarning();

  return children;
};
